// extracted by mini-css-extract-plugin
export default {"agentsContainer":"agents_agentsContainer__IFB97","tableCtn":"agents_tableCtn__wLhkZ","tablePaginationCtn":"agents_tablePaginationCtn__0NEoy"};